// Smoothly scrolls the first invalid form field into view after a failed
// validation. Forms in this codebase flag invalid inputs with the
// `input__clz` class, so the first match in DOM order is the first error.
//
// The scroll is deferred a tick so it runs *after* React has applied the
// error classes for the current submit. Shared across forms (Monetics, C&C,
// ...) to keep the behaviour uniform.

/** Class applied to a form field when its value is invalid. */
const ERROR_FIELD_SELECTOR = ".input__clz";
/** Delay (ms) before scrolling, so the error classes are in the DOM first. */
const SCROLL_DEFER_MS = 50;

export function scrollToFirstError(container?: HTMLElement | null): void {
    setTimeout(() => {
        const target = (container || document).querySelector(
            ERROR_FIELD_SELECTOR
        );
        target?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, SCROLL_DEFER_MS);
}
